import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import { ControlledCheckbox } from "@saleor/components/ControlledCheckbox";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

interface VoucherLimitsProps {
  data: VoucherDetailsPageFormData;
  defaultCurrency: string;
  disabled: boolean;
  errors: DiscountErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

const VoucherLimits = ({
  data,
  disabled,
  errors,
  onChange
}: VoucherLimitsProps) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["usageLimit"], errors);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Usage Limit",
          description: "voucher usage limit, header"
        })}
      />
      <CardContent>
        <ControlledCheckbox
          checked={data.hasUsageLimit}
          label={intl.formatMessage({
            defaultMessage:
              "Limit number of times this discount can be used in total"
          })}
          name={"hasUsageLimit" as keyof VoucherDetailsPageFormData}
          onChange={onChange}
        />
        {data.hasUsageLimit && (
          <TextField
            disabled={disabled}
            error={!!formErrors.usageLimit}
            helperText={getDiscountErrorMessage(formErrors.usageLimit, intl)}
            label={intl.formatMessage({
              defaultMessage: "Limit of Uses",
              description: "voucher"
            })}
            name={"usageLimit" as keyof VoucherDetailsPageFormData}
            value={data.usageLimit}
            onChange={onChange}
            type="number"
            inputProps={{
              min: 0
            }}
            fullWidth
          />
        )}
        <div />
        <ControlledCheckbox
          checked={data.hasApplyNumberPerCustomer}
          label={intl.formatMessage({
            defaultMessage: "Limit number of times use per customer"
          })}
          name={"hasApplyNumberPerCustomer" as keyof VoucherDetailsPageFormData}
          onChange={onChange}
        />
        {data.hasApplyNumberPerCustomer && (
          <TextField
            disabled={disabled}
            error={!!formErrors.usageLimit}
            helperText={getDiscountErrorMessage(formErrors.usageLimit, intl)}
            label={intl.formatMessage({
              defaultMessage: "Frequency of user use",
              description: "voucher"
            })}
            name={"applyNumberPerCustomer" as keyof VoucherDetailsPageFormData}
            value={data.applyNumberPerCustomer}
            onChange={onChange}
            type="number"
            inputProps={{
              min: 0
            }}
            fullWidth
          />
        )}
        <br />
        <ControlledCheckbox
          checked={data.applyShopAll}
          label={intl.formatMessage({
            defaultMessage: "Is it open",
            description: "limit voucher"
          })}
          name={"applyShopAll" as keyof VoucherDetailsPageFormData}
          onChange={onChange}
        />
        <br />
        <ControlledCheckbox
          checked={data.isAff}
          label={intl.formatMessage({
            defaultMessage: "Is aff url exclusive",
            description: "just aff url can use it"
          })}
          name={"isAff" as keyof VoucherDetailsPageFormData}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};
export default VoucherLimits;
